/* eslint-disable no-console */
import React, { useState, useEffect, Fragment } from 'react';
import LearnosityContext from './LearnosityContext';
import { observable } from 'legacy-packages/ft-cb';
import useLearnosityProvider from 'chameleon/ui-stack/hooks/use-learnosity-provider';

const LearnosityProvider = (props) => {
  const {
    children,
    className,
    readyListener,
    sessionId,
    itemReference,
    containerElement,
    apiType,
    initOptions,
  } = props;

  const { app, element, destroyLearnosityApi } = useLearnosityProvider({
    containerElement,
    apiType,
    initOptions,
    className,
    sessionId,
    itemReference,
  });

  const [learnosityDataProps, setLearnosityDataProps] = useState(null);

  useEffect(() => {
    if (app) {
      app.on &&
        app.on('test:start', () => {
          const { getActivity, getItems, getCurrentItem } = app;
          const otherProps = {
            activity: getActivity(),
            items: getItems(),
            currentItem: getCurrentItem(),
            render_with_captured_questions: true,
            app,
          };

          readyListener(app, otherProps);
          setLearnosityDataProps(otherProps);
        });
    }

    return () => {
      //setTimeout allows the children to unmount first
      setTimeout(() => {
        observable.clearIntervals();
        destroyLearnosityApi(app);
      }, 0);
    };
  }, [app]);

  return (
    <Fragment>
      {element}
      {!!learnosityDataProps && (
        <LearnosityContext.Provider value={learnosityDataProps}>
          {children}
        </LearnosityContext.Provider>
      )}
    </Fragment>
  );
};

LearnosityProvider.displayName = 'LearnosityProvider';

LearnosityProvider.defaultProps = {
  className: 'cb-learnosity-player',
  preview: false,
};

export default LearnosityProvider;
